import { useState } from 'react';

export default function RejectArticleForm({busy,error,retry,idea=false,onSubmit,onCancel}:{
  busy:boolean; error:string; retry:boolean;
  idea?:boolean;
  onSubmit:(reason:string)=>void; onCancel:()=>void;
}) {
  const [reason,setReason]=useState('');
  return <form onSubmit={event=>{event.preventDefault();if(!busy)onSubmit(reason);}} className="space-y-4">
    {!retry ? <div className="space-y-2">
      <label htmlFor="rejection-reason" className="block text-sm font-medium">Reason (optional)</label>
      <textarea id="rejection-reason" className="w-full rounded-md border border-input bg-background p-3 text-sm" rows={4} maxLength={1000} value={reason} disabled={busy} onChange={event=>setReason(event.target.value)} placeholder="E.g. Too abstract. I want wearable bridal looks, not keepsake still lifes." aria-describedby="rejection-feedback-help" />
      <p id="rejection-feedback-help" className="text-sm text-muted-foreground">Used for the replacement and future article ideas.</p>
    </div> : <p className="text-sm text-muted-foreground">Your original feedback is kept.</p>}
    {error && <p role="alert" className="desk-error">{error}</p>}
    <div className="flex justify-end gap-2">
      <button type="button" className="desk-button secondary" disabled={busy} onClick={onCancel}>Cancel</button>
      <button type="submit" className="inline-flex h-10 items-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground disabled:opacity-50" disabled={busy}>{busy?idea?'Replacing…':'Deleting…':retry?'Retry deletion & replacement':idea?'Reject & replace':'Delete & replace'}</button>
    </div>
  </form>;
}
